import { ClientGateway } from "@kex/api";
import { useMutation } from "@tanstack/react-query";

import { authApi } from "@shared/api";

type MutationData = Omit<ClientGateway.SignInRequest, "otpDeliveryType">;

export const useSignIn = () => {
  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: (data: MutationData) =>
      authApi.postApiV1AuthSignIn({
        signInRequest: data,
      }),
  });

  return { error, singIn: mutateAsync, isPending };
};
